// extracted by mini-css-extract-plugin
export default {"header":"MetropoleCCASHeader_header__d15HA","logo":"MetropoleCCASHeader_logo__YptfC"};